// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._3d7yj31 {
  max-width: 900px;
  margin: 0 auto;
  padding: 24px;
}

.XLWio4sM {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #a0a0a0;
  font-size: 14px;
  margin-bottom: 16px;
  cursor: pointer;
}

.XLWio4sM:hover {
  color: #4ecca3;
  text-decoration: none;
}

.Toj_DwFS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.Pj8mC1IA {
  font-size: 14px;
  color: #a0a0a0;
}

.ouhtv83O {
  display: flex;
  gap: 8px;
}

.CDaCBE5h {
  padding: 6px 16px;
  border: 1px solid #2a2a4a;
  border-radius: 6px;
  background: transparent;
  color: #a0a0a0;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.CDaCBE5h:hover {
  border-color: #4ecca3;
  color: #e0e0e0;
}

.lp2sGlFp {
  background: #4ecca3;
  color: #1a1a2e;
  border-color: #4ecca3;
  font-weight: 600;
}

/* Explanation */
.bQtSX0O8 {
  line-height: 1.7;
  font-size: 16px;
  color: #e0e0e0;
}

.bQtSX0O8 h1 {
  font-size: 24px;
  color: #4ecca3;
  margin-bottom: 16px;
}

.bQtSX0O8 p {
  margin-bottom: 12px;
}

.bQtSX0O8 ul {
  margin: 8px 0 12px 20px;
}

.bQtSX0O8 li {
  margin-bottom: 4px;
}

.bQtSX0O8 code {
  background: #2a2a4a;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 14px;
  color: #4ecca3;
}

.bQtSX0O8 pre {
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 8px;
  padding: 16px;
  margin: 12px 0;
  overflow-x: auto;
}

.bQtSX0O8 pre code {
  background: none;
  padding: 0;
  font-size: 14px;
  color: #e0e0e0;
}

.bQtSX0O8 h2 {
  font-size: 20px;
  color: #4ecca3;
  margin: 20px 0 12px;
}

.bQtSX0O8 h3 {
  font-size: 17px;
  color: #4ecca3;
  margin: 16px 0 8px;
}

.bQtSX0O8 blockquote {
  border-left: 3px solid #4ecca3;
  margin: 12px 0;
  padding: 8px 16px;
  color: #c0c0c0;
  background: #16213e;
  border-radius: 0 8px 8px 0;
}

.bQtSX0O8 blockquote p {
  margin-bottom: 4px;
}

.eBOC9_40 {
  overflow-x: auto;
  margin: 12px 0;
}

.bQtSX0O8 table,
.CeFGrOL5 table {
  border-collapse: collapse;
  width: 100%;
  font-size: 14px;
}

.bQtSX0O8 th,
.bQtSX0O8 td,
.CeFGrOL5 th,
.CeFGrOL5 td {
  border: 1px solid #2a2a4a;
  padding: 8px 12px;
  text-align: left;
}

.bQtSX0O8 th,
.CeFGrOL5 th {
  background: #16213e;
  color: #4ecca3;
  font-weight: 600;
}

.bQtSX0O8 td,
.CeFGrOL5 td {
  background: #1a1a2e;
}

.bQtSX0O8 tr:hover td,
.CeFGrOL5 tr:hover td {
  background: #16213e;
}

.ErADJfoJ {
  background: #16213e;
  border-left: 3px solid #4ecca3;
  padding: 12px 16px;
  margin: 16px 0;
  border-radius: 0 8px 8px 0;
  font-size: 14px;
  color: #c0c0c0;
}

.kTtMvgdM {
  color: #4ecca3;
  font-weight: 600;
  margin-bottom: 4px;
}

/* Example Runner */
.Pz65zjR_ {
  margin-top: 24px;
}

._AsMDeBE {
  font-size: 13px;
  color: #a0a0a0;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 8px;
}

.MLtfGb04 {
  color: #c0c0c0;
  margin-bottom: 12px;
  font-size: 15px;
}

.GRmDMZu7 {
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 8px;
  padding: 16px;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  font-size: 14px;
  color: #e0e0e0;
  margin-bottom: 12px;
}

.WaZRR32m {
  padding: 8px 20px;
  background: #4ecca3;
  color: #1a1a2e;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.WaZRR32m:hover {
  background: #3dbb92;
}

/* Result Table */
.ttELfGtq {
  margin-top: 16px;
  overflow-x: auto;
}

.qKCmW8hu {
  font-size: 13px;
  color: #a0a0a0;
  margin-bottom: 8px;
}

.gu4HbUy5 {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin-top: 8px;
}

.gu4HbUy5 th {
  background: #2a2a4a;
  color: #4ecca3;
  padding: 8px 12px;
  text-align: left;
  font-weight: 600;
  border-bottom: 2px solid #4ecca3;
}

.gu4HbUy5 td {
  padding: 8px 12px;
  border-bottom: 1px solid #2a2a4a;
  color: #e0e0e0;
}

.gu4HbUy5 tr:hover td {
  background: #1e2a4a;
}

.ihU4ST2H {
  font-size: 12px;
  color: #a0a0a0;
  margin-top: 4px;
}

.Z6W5B3ms {
  color: #e74c3c;
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.3);
  border-radius: 6px;
  padding: 12px;
  font-size: 14px;
  margin-top: 8px;
}

.sdeLBQcf {
  color: #a0a0a0;
  font-style: italic;
  padding: 16px;
  text-align: center;
}

/* Task Panel */
.qUMwCQCe {
  margin-top: 24px;
}

.CeFGrOL5 {
  font-size: 16px;
  color: #e0e0e0;
  margin-bottom: 16px;
  line-height: 1.6;
}

.CeFGrOL5 code {
  background: #2a2a4a;
  padding: 2px 6px;
  border-radius: 3px;
  color: #4ecca3;
  font-size: 14px;
}

.rRXBHG10 {
  border: 1px solid #2a2a4a;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
}

._44KFjMS {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
}

.dQbzjy2k {
  padding: 8px 16px;
  background: transparent;
  color: #a0a0a0;
  border: 1px solid #2a2a4a;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.dQbzjy2k:hover {
  border-color: #a0a0a0;
  color: #e0e0e0;
}

.dQbzjy2k:disabled {
  opacity: 0.5;
  cursor: default;
}

.rShC68sJ {
  font-size: 12px;
  color: #a0a0a0;
  margin-left: auto;
}

/* Feedback */
.JAG5oLqw {
  background: rgba(78, 204, 163, 0.1);
  border: 1px solid rgba(78, 204, 163, 0.3);
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
}

.T_hTM6ez {
  color: #4ecca3;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.M2nQDfnR {
  font-size: 13px;
  color: #a0a0a0;
  margin-top: 8px;
}

.trEIJ_rm {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 8px 0;
}

.i6Pbv3QC {
  display: inline-block;
  padding: 3px 8px;
  background: rgba(78, 204, 163, 0.15);
  border: 1px solid rgba(78, 204, 163, 0.3);
  border-radius: 4px;
  font-size: 12px;
  color: #4ecca3;
}

._3JUN4Eu {
  font-size: 16px;
  font-weight: 600;
  color: #f1c40f;
  margin: 8px 0;
}

.EzOGQuFz {
  margin: 8px 0;
}

.yvZqCJCv {
  padding: 6px 10px;
  background: rgba(241, 196, 15, 0.1);
  border: 1px solid rgba(241, 196, 15, 0.3);
  border-radius: 6px;
  font-size: 14px;
  color: #f1c40f;
  margin-bottom: 4px;
}

.MzUY7uSN {
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.3);
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
}

.SUXVAP8b {
  color: #e74c3c;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}

.JlFxVDUy {
  margin-top: 8px;
  font-size: 14px;
  color: #c0c0c0;
}

.OnaJJmXS {
  display: flex;
  gap: 24px;
  margin-top: 12px;
}

.PWueh4Wz {
  flex: 1;
  overflow-x: auto;
}

.LORUJhEx {
  font-size: 12px;
  color: #a0a0a0;
  margin-bottom: 4px;
}

/* Hints */
.EYYzEaBc {
  margin-top: 12px;
}

.CuyQYYLh {
  background: #16213e;
  border-left: 3px solid #f39c12;
  padding: 8px 12px;
  margin-bottom: 8px;
  border-radius: 0 6px 6px 0;
  font-size: 14px;
  color: #c0c0c0;
}

/* Navigation */
.DeSQjOdF {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #2a2a4a;
  gap: 12px;
}

.kRC64WQb {
  padding: 10px 24px;
  background: #4ecca3;
  color: #1a1a2e;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  text-decoration: none;
  margin-left: auto;
}

.kRC64WQb:hover {
  background: #3dbb92;
  text-decoration: none;
  color: #1a1a2e;
}

.xU0hDa5a {
  padding: 10px 24px;
  background: transparent;
  color: #a0a0a0;
  border: 1px solid #2a2a4a;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
}

.xU0hDa5a:hover {
  border-color: #4ecca3;
  color: #e0e0e0;
  text-decoration: none;
}

/* Tables reference */
.szYSVVsG {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #2a2a4a;
  font-size: 13px;
  color: #a0a0a0;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

.szYSVVsG span {
  color: #4ecca3;
  margin: 0 4px;
}

/* Loading */
.ZbbviOnN {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  color: #a0a0a0;
  font-size: 16px;
}

/* Schema reference */
.KHFk3esl {
  margin: 12px 0 8px;
}

.iIxvM1A2 {
  background: rgba(78, 204, 163, 0.1);
  border: 1px solid rgba(78, 204, 163, 0.3);
  color: #4ecca3;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s;
}

.iIxvM1A2:hover {
  background: rgba(78, 204, 163, 0.2);
}

.AevbE6T2 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 10px;
  margin-top: 10px;
  padding: 12px;
  background: #0f3460;
  border-radius: 8px;
  border: 1px solid #2a2a4a;
}

.InfCtpdp {
  background: #16213e;
  border-radius: 6px;
  padding: 8px;
  border: 1px solid #2a2a4a;
}

.hqm3lhzY {
  font-weight: 600;
  color: #4ecca3;
  font-size: 13px;
  margin-bottom: 6px;
  padding-bottom: 4px;
  border-bottom: 1px solid #2a2a4a;
}

.j017XvOt {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.xRB8fNDG {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  padding: 1px 0;
}

.azHLsjVz {
  color: #e0e0e0;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
}

.hNHP9GR4 {
  color: #888;
  font-size: 10px;
  text-transform: uppercase;
}

/* Responsive: 800px breakpoint */
@media (max-width: 800px) {
  ._3d7yj31 {
    padding: 12px;
  }

  .Toj_DwFS {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .ouhtv83O {
    width: 100%;
  }

  .CDaCBE5h, .lp2sGlFp {
    flex: 1;
    text-align: center;
    padding: 8px 8px;
    font-size: 12px;
  }

  ._44KFjMS {
    flex-wrap: wrap;
  }

  .rShC68sJ {
    display: none;
  }

  .OnaJJmXS {
    flex-direction: column;
    gap: 12px;
  }

  .DeSQjOdF {
    flex-direction: column;
  }

  .kRC64WQb, .xU0hDa5a {
    width: 100%;
    text-align: center;
  }
}

/* Responsive: 480px phone breakpoint */
@media (max-width: 480px) {
  ._3d7yj31 {
    padding: 8px;
  }

  .bQtSX0O8 {
    font-size: 14px;
  }

  .bQtSX0O8 h1 {
    font-size: 20px;
  }

  .bQtSX0O8 h2 {
    font-size: 17px;
  }

  .bQtSX0O8 h3 {
    font-size: 15px;
  }

  .bQtSX0O8 pre {
    padding: 10px;
    font-size: 12px;
  }

  .bQtSX0O8 code {
    font-size: 12px;
  }

  .CeFGrOL5 {
    font-size: 14px;
  }

  .CDaCBE5h, .lp2sGlFp {
    padding: 6px 4px;
    font-size: 11px;
  }

  ._44KFjMS {
    gap: 8px;
  }

  .WaZRR32m {
    padding: 8px 14px;
    font-size: 13px;
  }

  .dQbzjy2k {
    padding: 6px 10px;
    font-size: 13px;
  }

  .gu4HbUy5 th,
  .gu4HbUy5 td {
    padding: 6px 8px;
    font-size: 12px;
  }

  .AevbE6T2 {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 6px;
    padding: 8px;
  }

  .kRC64WQb, .xU0hDa5a {
    padding: 8px 16px;
    font-size: 13px;
  }

  .IZYnill1 {
    padding: 20px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/LessonView.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;;;;EAIE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qDAAqD;EACrD,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,4DAA4D;IAC5D,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 24px;\n}\n\n.backLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #a0a0a0;\n  font-size: 14px;\n  margin-bottom: 16px;\n  cursor: pointer;\n}\n\n.backLink:hover {\n  color: #4ecca3;\n  text-decoration: none;\n}\n\n.lessonHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.lessonTitle {\n  font-size: 14px;\n  color: #a0a0a0;\n}\n\n.phaseNav {\n  display: flex;\n  gap: 8px;\n}\n\n.phaseBtn {\n  padding: 6px 16px;\n  border: 1px solid #2a2a4a;\n  border-radius: 6px;\n  background: transparent;\n  color: #a0a0a0;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.phaseBtn:hover {\n  border-color: #4ecca3;\n  color: #e0e0e0;\n}\n\n.phaseBtnActive {\n  composes: phaseBtn;\n  background: #4ecca3;\n  color: #1a1a2e;\n  border-color: #4ecca3;\n  font-weight: 600;\n}\n\n/* Explanation */\n.explanation {\n  line-height: 1.7;\n  font-size: 16px;\n  color: #e0e0e0;\n}\n\n.explanation h1 {\n  font-size: 24px;\n  color: #4ecca3;\n  margin-bottom: 16px;\n}\n\n.explanation p {\n  margin-bottom: 12px;\n}\n\n.explanation ul {\n  margin: 8px 0 12px 20px;\n}\n\n.explanation li {\n  margin-bottom: 4px;\n}\n\n.explanation code {\n  background: #2a2a4a;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 14px;\n  color: #4ecca3;\n}\n\n.explanation pre {\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 12px 0;\n  overflow-x: auto;\n}\n\n.explanation pre code {\n  background: none;\n  padding: 0;\n  font-size: 14px;\n  color: #e0e0e0;\n}\n\n.explanation h2 {\n  font-size: 20px;\n  color: #4ecca3;\n  margin: 20px 0 12px;\n}\n\n.explanation h3 {\n  font-size: 17px;\n  color: #4ecca3;\n  margin: 16px 0 8px;\n}\n\n.explanation blockquote {\n  border-left: 3px solid #4ecca3;\n  margin: 12px 0;\n  padding: 8px 16px;\n  color: #c0c0c0;\n  background: #16213e;\n  border-radius: 0 8px 8px 0;\n}\n\n.explanation blockquote p {\n  margin-bottom: 4px;\n}\n\n.tableWrapper {\n  overflow-x: auto;\n  margin: 12px 0;\n}\n\n.explanation table,\n.taskDescription table {\n  border-collapse: collapse;\n  width: 100%;\n  font-size: 14px;\n}\n\n.explanation th,\n.explanation td,\n.taskDescription th,\n.taskDescription td {\n  border: 1px solid #2a2a4a;\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.explanation th,\n.taskDescription th {\n  background: #16213e;\n  color: #4ecca3;\n  font-weight: 600;\n}\n\n.explanation td,\n.taskDescription td {\n  background: #1a1a2e;\n}\n\n.explanation tr:hover td,\n.taskDescription tr:hover td {\n  background: #16213e;\n}\n\n.analogy {\n  background: #16213e;\n  border-left: 3px solid #4ecca3;\n  padding: 12px 16px;\n  margin: 16px 0;\n  border-radius: 0 8px 8px 0;\n  font-size: 14px;\n  color: #c0c0c0;\n}\n\n.analogyLabel {\n  color: #4ecca3;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n/* Example Runner */\n.exampleSection {\n  margin-top: 24px;\n}\n\n.sectionLabel {\n  font-size: 13px;\n  color: #a0a0a0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 8px;\n}\n\n.exampleDescription {\n  color: #c0c0c0;\n  margin-bottom: 12px;\n  font-size: 15px;\n}\n\n.sqlBlock {\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 8px;\n  padding: 16px;\n  font-family: 'JetBrains Mono', 'Fira Code', monospace;\n  font-size: 14px;\n  color: #e0e0e0;\n  margin-bottom: 12px;\n}\n\n.runBtn {\n  padding: 8px 20px;\n  background: #4ecca3;\n  color: #1a1a2e;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.runBtn:hover {\n  background: #3dbb92;\n}\n\n/* Result Table */\n.resultSection {\n  margin-top: 16px;\n  overflow-x: auto;\n}\n\n.resultLabel {\n  font-size: 13px;\n  color: #a0a0a0;\n  margin-bottom: 8px;\n}\n\n.resultTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n.resultTable th {\n  background: #2a2a4a;\n  color: #4ecca3;\n  padding: 8px 12px;\n  text-align: left;\n  font-weight: 600;\n  border-bottom: 2px solid #4ecca3;\n}\n\n.resultTable td {\n  padding: 8px 12px;\n  border-bottom: 1px solid #2a2a4a;\n  color: #e0e0e0;\n}\n\n.resultTable tr:hover td {\n  background: #1e2a4a;\n}\n\n.rowCount {\n  font-size: 12px;\n  color: #a0a0a0;\n  margin-top: 4px;\n}\n\n.errorMessage {\n  color: #e74c3c;\n  background: rgba(231, 76, 60, 0.1);\n  border: 1px solid rgba(231, 76, 60, 0.3);\n  border-radius: 6px;\n  padding: 12px;\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n.emptyResult {\n  color: #a0a0a0;\n  font-style: italic;\n  padding: 16px;\n  text-align: center;\n}\n\n/* Task Panel */\n.taskSection {\n  margin-top: 24px;\n}\n\n.taskDescription {\n  font-size: 16px;\n  color: #e0e0e0;\n  margin-bottom: 16px;\n  line-height: 1.6;\n}\n\n.taskDescription code {\n  background: #2a2a4a;\n  padding: 2px 6px;\n  border-radius: 3px;\n  color: #4ecca3;\n  font-size: 14px;\n}\n\n.editorWrapper {\n  border: 1px solid #2a2a4a;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.hintBtn {\n  padding: 8px 16px;\n  background: transparent;\n  color: #a0a0a0;\n  border: 1px solid #2a2a4a;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.hintBtn:hover {\n  border-color: #a0a0a0;\n  color: #e0e0e0;\n}\n\n.hintBtn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.shortcut {\n  font-size: 12px;\n  color: #a0a0a0;\n  margin-left: auto;\n}\n\n/* Feedback */\n.feedbackSuccess {\n  background: rgba(78, 204, 163, 0.1);\n  border: 1px solid rgba(78, 204, 163, 0.3);\n  border-radius: 8px;\n  padding: 16px;\n  margin-top: 16px;\n}\n\n.feedbackSuccessTitle {\n  color: #4ecca3;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.feedbackStats {\n  font-size: 13px;\n  color: #a0a0a0;\n  margin-top: 8px;\n}\n\n.feedbackBonuses {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 8px 0;\n}\n\n.bonusTag {\n  display: inline-block;\n  padding: 3px 8px;\n  background: rgba(78, 204, 163, 0.15);\n  border: 1px solid rgba(78, 204, 163, 0.3);\n  border-radius: 4px;\n  font-size: 12px;\n  color: #4ecca3;\n}\n\n.levelUp {\n  font-size: 16px;\n  font-weight: 600;\n  color: #f1c40f;\n  margin: 8px 0;\n}\n\n.achievementUnlock {\n  margin: 8px 0;\n}\n\n.achievementItem {\n  padding: 6px 10px;\n  background: rgba(241, 196, 15, 0.1);\n  border: 1px solid rgba(241, 196, 15, 0.3);\n  border-radius: 6px;\n  font-size: 14px;\n  color: #f1c40f;\n  margin-bottom: 4px;\n}\n\n.feedbackError {\n  background: rgba(231, 76, 60, 0.1);\n  border: 1px solid rgba(231, 76, 60, 0.3);\n  border-radius: 8px;\n  padding: 16px;\n  margin-top: 16px;\n}\n\n.feedbackErrorTitle {\n  color: #e74c3c;\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.feedbackHint {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #c0c0c0;\n}\n\n.diffContainer {\n  display: flex;\n  gap: 24px;\n  margin-top: 12px;\n}\n\n.diffBlock {\n  flex: 1;\n  overflow-x: auto;\n}\n\n.diffLabel {\n  font-size: 12px;\n  color: #a0a0a0;\n  margin-bottom: 4px;\n}\n\n/* Hints */\n.hints {\n  margin-top: 12px;\n}\n\n.hint {\n  background: #16213e;\n  border-left: 3px solid #f39c12;\n  padding: 8px 12px;\n  margin-bottom: 8px;\n  border-radius: 0 6px 6px 0;\n  font-size: 14px;\n  color: #c0c0c0;\n}\n\n/* Navigation */\n.lessonNav {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #2a2a4a;\n  gap: 12px;\n}\n\n.nextBtn {\n  padding: 10px 24px;\n  background: #4ecca3;\n  color: #1a1a2e;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n  text-decoration: none;\n  margin-left: auto;\n}\n\n.nextBtn:hover {\n  background: #3dbb92;\n  text-decoration: none;\n  color: #1a1a2e;\n}\n\n.prevBtn {\n  padding: 10px 24px;\n  background: transparent;\n  color: #a0a0a0;\n  border: 1px solid #2a2a4a;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-decoration: none;\n}\n\n.prevBtn:hover {\n  border-color: #4ecca3;\n  color: #e0e0e0;\n  text-decoration: none;\n}\n\n/* Tables reference */\n.tablesRef {\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #2a2a4a;\n  font-size: 13px;\n  color: #a0a0a0;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n}\n\n.tablesRef span {\n  color: #4ecca3;\n  margin: 0 4px;\n}\n\n/* Loading */\n.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  color: #a0a0a0;\n  font-size: 16px;\n}\n\n/* Schema reference */\n.schemaRef {\n  margin: 12px 0 8px;\n}\n\n.schemaToggle {\n  background: rgba(78, 204, 163, 0.1);\n  border: 1px solid rgba(78, 204, 163, 0.3);\n  color: #4ecca3;\n  padding: 6px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.2s;\n}\n\n.schemaToggle:hover {\n  background: rgba(78, 204, 163, 0.2);\n}\n\n.schemaTables {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 10px;\n  margin-top: 10px;\n  padding: 12px;\n  background: #0f3460;\n  border-radius: 8px;\n  border: 1px solid #2a2a4a;\n}\n\n.schemaTable {\n  background: #16213e;\n  border-radius: 6px;\n  padding: 8px;\n  border: 1px solid #2a2a4a;\n}\n\n.schemaTableName {\n  font-weight: 600;\n  color: #4ecca3;\n  font-size: 13px;\n  margin-bottom: 6px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid #2a2a4a;\n}\n\n.schemaColumns {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.schemaColumn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 11px;\n  padding: 1px 0;\n}\n\n.schemaColName {\n  color: #e0e0e0;\n  font-family: 'JetBrains Mono', 'Fira Code', monospace;\n}\n\n.schemaColType {\n  color: #888;\n  font-size: 10px;\n  text-transform: uppercase;\n}\n\n/* Responsive: 800px breakpoint */\n@media (max-width: 800px) {\n  .container {\n    padding: 12px;\n  }\n\n  .lessonHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .phaseNav {\n    width: 100%;\n  }\n\n  .phaseBtn, .phaseBtnActive {\n    flex: 1;\n    text-align: center;\n    padding: 8px 8px;\n    font-size: 12px;\n  }\n\n  .actions {\n    flex-wrap: wrap;\n  }\n\n  .shortcut {\n    display: none;\n  }\n\n  .diffContainer {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .lessonNav {\n    flex-direction: column;\n  }\n\n  .nextBtn, .prevBtn {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n/* Responsive: 480px phone breakpoint */\n@media (max-width: 480px) {\n  .container {\n    padding: 8px;\n  }\n\n  .explanation {\n    font-size: 14px;\n  }\n\n  .explanation h1 {\n    font-size: 20px;\n  }\n\n  .explanation h2 {\n    font-size: 17px;\n  }\n\n  .explanation h3 {\n    font-size: 15px;\n  }\n\n  .explanation pre {\n    padding: 10px;\n    font-size: 12px;\n  }\n\n  .explanation code {\n    font-size: 12px;\n  }\n\n  .taskDescription {\n    font-size: 14px;\n  }\n\n  .phaseBtn, .phaseBtnActive {\n    padding: 6px 4px;\n    font-size: 11px;\n  }\n\n  .actions {\n    gap: 8px;\n  }\n\n  .runBtn {\n    padding: 8px 14px;\n    font-size: 13px;\n  }\n\n  .hintBtn {\n    padding: 6px 10px;\n    font-size: 13px;\n  }\n\n  .resultTable th,\n  .resultTable td {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n\n  .schemaTables {\n    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n    gap: 6px;\n    padding: 8px;\n  }\n\n  .nextBtn, .prevBtn {\n    padding: 8px 16px;\n    font-size: 13px;\n  }\n\n  .popupCard {\n    padding: 20px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_3d7yj31`,
	"backLink": `XLWio4sM`,
	"lessonHeader": `Toj_DwFS`,
	"lessonTitle": `Pj8mC1IA`,
	"phaseNav": `ouhtv83O`,
	"phaseBtn": `CDaCBE5h`,
	"phaseBtnActive": `lp2sGlFp CDaCBE5h`,
	"explanation": `bQtSX0O8`,
	"tableWrapper": `eBOC9_40`,
	"taskDescription": `CeFGrOL5`,
	"analogy": `ErADJfoJ`,
	"analogyLabel": `kTtMvgdM`,
	"exampleSection": `Pz65zjR_`,
	"sectionLabel": `_AsMDeBE`,
	"exampleDescription": `MLtfGb04`,
	"sqlBlock": `GRmDMZu7`,
	"runBtn": `WaZRR32m`,
	"resultSection": `ttELfGtq`,
	"resultLabel": `qKCmW8hu`,
	"resultTable": `gu4HbUy5`,
	"rowCount": `ihU4ST2H`,
	"errorMessage": `Z6W5B3ms`,
	"emptyResult": `sdeLBQcf`,
	"taskSection": `qUMwCQCe`,
	"editorWrapper": `rRXBHG10`,
	"actions": `_44KFjMS`,
	"hintBtn": `dQbzjy2k`,
	"shortcut": `rShC68sJ`,
	"feedbackSuccess": `JAG5oLqw`,
	"feedbackSuccessTitle": `T_hTM6ez`,
	"feedbackStats": `M2nQDfnR`,
	"feedbackBonuses": `trEIJ_rm`,
	"bonusTag": `i6Pbv3QC`,
	"levelUp": `_3JUN4Eu`,
	"achievementUnlock": `EzOGQuFz`,
	"achievementItem": `yvZqCJCv`,
	"feedbackError": `MzUY7uSN`,
	"feedbackErrorTitle": `SUXVAP8b`,
	"feedbackHint": `JlFxVDUy`,
	"diffContainer": `OnaJJmXS`,
	"diffBlock": `PWueh4Wz`,
	"diffLabel": `LORUJhEx`,
	"hints": `EYYzEaBc`,
	"hint": `CuyQYYLh`,
	"lessonNav": `DeSQjOdF`,
	"nextBtn": `kRC64WQb`,
	"prevBtn": `xU0hDa5a`,
	"tablesRef": `szYSVVsG`,
	"loading": `ZbbviOnN`,
	"schemaRef": `KHFk3esl`,
	"schemaToggle": `iIxvM1A2`,
	"schemaTables": `AevbE6T2`,
	"schemaTable": `InfCtpdp`,
	"schemaTableName": `hqm3lhzY`,
	"schemaColumns": `j017XvOt`,
	"schemaColumn": `xRB8fNDG`,
	"schemaColName": `azHLsjVz`,
	"schemaColType": `hNHP9GR4`,
	"popupCard": `IZYnill1`
};
export default ___CSS_LOADER_EXPORT___;
